import { Component, OnInit } from '@angular/core';
import {RatingsPageService, SingleRatingData} from "../../../services/ratings-page.service";

@Component({
  selector: 'app-ratings-page-table',
  templateUrl: './ratings-page-table.component.html',
  styleUrls: ['./ratings-page-table.component.scss']
})
export class RatingsPageTableComponent implements OnInit {

  constructor(
    private ratingsPageService: RatingsPageService
  ) { }

  public displayedColumnsNames: string[] = [];

  private _dataKeys = [
    'statusName',
    'countryName',
    'cityName',
    'gameName',
  ];

  ngOnInit(): void {
    this.displayedColumnsNames = this.ratingsPageService.headers;
    this.ratingsPageService.getRatingsList().subscribe((response: SingleRatingData[]) => {
      const transformersSet = this.ratingsPageService.dataTransformersSet;
      this.ratingsPageService.acquiredRatingsList = response;
      this.ratingsPageService.acquiredRatingsList.forEach((singleRatingRow) => {
        Object.keys(transformersSet).forEach((key) => {
          singleRatingRow[key] = transformersSet[key](singleRatingRow[key]);
        });
      });
    });
  }

  getRatingsList(): SingleRatingData[] {
    return this.ratingsPageService.acquiredRatingsList;
  }

  headerToKey() {
    return this.ratingsPageService.headersToKeysTranslator;
  }

  transformData(data) {
    if (typeof data === 'object') {
      return data[this._dataKeys.find(key => data[key] !== undefined)];
    }
    return data;
  }

  clickHandler($event, data: SingleRatingData) {

    window.open(`/ratings_details?detailsId=${data.rating_id}`, '_self');
  }
}
